export const PLAYER_TAB_VALUES = {
    CONSENSUS: "consensus",
    DRAFT_ODDS: "draft-odds",
    STATS: "stats",
    FILM: "film",
    COMPARE: "compare",
    DISCUSSION: "discussion",
};

export const DEFAULT_PLAYER_TAB = PLAYER_TAB_VALUES.CONSENSUS;

export const VALID_PLAYER_TABS = new Set(Object.values(PLAYER_TAB_VALUES));

const TAB_META = {
    [PLAYER_TAB_VALUES.CONSENSUS]: {
        label: "Consensus Rankings",
        description: (firstName, lastName) =>
            `Track ${firstName} ${lastName}'s consensus ranking history, scout rankings, and draft stock on Hockey Pipeline.`,
    },
    [PLAYER_TAB_VALUES.DRAFT_ODDS]: {
        label: "Draft Odds",
        description: (firstName, lastName) =>
            `Simulated NHL draft odds and pick probabilities for ${firstName} ${lastName} on Hockey Pipeline.`,
    },
    [PLAYER_TAB_VALUES.STATS]: {
        label: "Stats",
        description: (firstName, lastName) =>
            `Draft-year statistics and performance data for ${firstName} ${lastName} on Hockey Pipeline.`,
    },
    [PLAYER_TAB_VALUES.FILM]: {
        label: "Film",
        description: (firstName, lastName) =>
            `Scouting video and film breakdown for ${firstName} ${lastName} on Hockey Pipeline.`,
    },
    [PLAYER_TAB_VALUES.COMPARE]: {
        label: "Compare",
        description: (firstName, lastName) =>
            `Compare ${firstName} ${lastName}'s stats and rankings against other prospects on Hockey Pipeline.`,
    },
    [PLAYER_TAB_VALUES.DISCUSSION]: {
        label: "Discussion",
        description: (firstName, lastName) =>
            `Join the discussion about ${firstName} ${lastName} on Hockey Pipeline.`,
    },
};

export function normalizePlayerTab(tab, { hasFilm = true } = {}) {
    if (!tab || !VALID_PLAYER_TABS.has(tab)) {
        return DEFAULT_PLAYER_TAB;
    }
    if (tab === PLAYER_TAB_VALUES.FILM && !hasFilm) {
        return DEFAULT_PLAYER_TAB;
    }
    return tab;
}

export function buildPlayerPagePath(playerId, tab = DEFAULT_PLAYER_TAB) {
    if (!playerId) return "/players";
    if (!tab || tab === DEFAULT_PLAYER_TAB) {
        return `/player/${playerId}`;
    }
    return `/player/${playerId}?tab=${encodeURIComponent(tab)}`;
}

export function buildPlayerPageUrl(playerId, tab = DEFAULT_PLAYER_TAB, origin = "https://hockeypipeline.com") {
    return `${origin}${buildPlayerPagePath(playerId, tab)}`;
}

export function buildSharePlayerUrl(playerId, tab = DEFAULT_PLAYER_TAB, origin = "https://hockeypipeline.com") {
    if (!playerId) return origin;
    if (!tab || tab === DEFAULT_PLAYER_TAB) {
        return `${origin}/share/players/${playerId}`;
    }
    return `${origin}/share/players/${playerId}?tab=${encodeURIComponent(tab)}`;
}

export function getPlayerTabMeta(tab, player) {
    const normalizedTab = normalizePlayerTab(tab);
    const config = TAB_META[normalizedTab] || TAB_META[DEFAULT_PLAYER_TAB];
    const firstName = player?.first_name || "";
    const lastName = player?.last_name || "";
    const name = `${firstName} ${lastName}`.trim() || "Player";

    if (normalizedTab === DEFAULT_PLAYER_TAB) {
        return {
            title: `${name} - Hockey Pipeline`,
            description: config.description(firstName, lastName),
        };
    }

    return {
        title: `${name} — ${config.label} | Hockey Pipeline`,
        description: config.description(firstName, lastName),
    };
}
